// components/MemberCardEmpty.tsx
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Smartphone, QrCode } from "lucide-react";

export function MemberCardEmpty() {
  return (
    <Card className="w-full max-w-md mx-auto text-center shadow-md bg-white/10 backdrop-blur-md border border-white/30 rounded-2xl p-2">
      <CardContent className="p-0">
        <div className="bg-white bg-[url('/bg-pattern.png')] bg-cover bg-center border border-dashed border-white/30 rounded-xl flex flex-col items-center justify-center space-y-4 ">
          <img
              src="/illustration.png"
              alt="illustration"
              className="w-[250px] contain mb-0"
            />
          <CardHeader className="flex flex-col items-center">
            <CardTitle className="text-3xl font-semibold text-black mb-6">
              Validasi Kartu Anggota
            </CardTitle>
            {/* Instruksi Scan QR Code Manual */}
            <div className="bg-blue-50 border border-blue-200 border-dashed border-2 rounded-lg p-4 mb-6">
              <ol className="text-sm text-blue-700 text-left space-y-1">
                <li className="flex items-start">
                  <span className="font-bold mr-2">1.</span>
                  <span>Buka aplikasi kamera atau Google Lens di handphone Anda</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">2.</span>
                  <span>Arahkan kamera ke QR Code di Kartu Anggota</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">3.</span>
                  <span>Tap notifikasi yang muncul untuk membuka link</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">4.</span>
                  <span>Kartu Anggota Digital Anda akan ditampilkan disini</span>
                </li>
              </ol>
            </div>
            
            <p className="text-xs text-black/60 max-w-xs text-center pt-4">
              💡 <strong>Tips:</strong> Pastikan QR Code terlihat jelas dan pencahayaan cukup untuk hasil scan yang optimal.
            </p>
          </CardHeader>
        </div>
      </CardContent>
    </Card>
  );
}
